import { useStore } from "vuex";
import { useCategoriesStore } from "@/stores/categories/index.ts";

async function fetchAndSetCategory(store, id) {
  if (id && id !== "None") {
    try {
      const categoryData = await store.dispatch("api/fetchCategory", { id });
      await store.dispatch(
        "setPageData",
        { pageName: "Category", data: categoryData },
        { root: true }
      );
    } catch (e) {
      console.error(e);
      console.error("Home Category 404");
    }
  }
}

export default function useHomeData() {
  const store = useStore();
  const categoriesStore = useCategoriesStore();

  async function loadHomeData() {
    // header relies on home layout so we need to load home data on every route
    await Promise.all([
      categoriesStore.fetch(),
      store.dispatch("api/fetchAllCategories"),
    ]);

    const layout = store.getters.getStoreVar(
      "Home",
      "page",
      "layout",
      "layout"
    );
    const gridCategoryId = store.getters.getStoreVar(
      "Home",
      "styling",
      "dropdown",
      "gridCategoryId"
    );
    const carouselCategoryIds = store.getters.getStoreVar(
      "Home",
      "styling",
      "dropdown",
      "carouselCategoryIds"
    );

    switch (layout) {
      case "FiveColumnHomeLayout":
        await fetchAndSetCategory(store, gridCategoryId);
        break;

      case "SplitScreenSpotlight":
        await fetchAndSetCategory(store, gridCategoryId);
        if (carouselCategoryIds.length) {
          await Promise.all(
            carouselCategoryIds.map((id) => fetchAndSetCategory(store, id))
          );
        }
        break;

      case "HomeLayout2":
      case "HomeLayout9":
        if (carouselCategoryIds.length) {
          await Promise.all(
            carouselCategoryIds.map((id) => fetchAndSetCategory(store, id))
          );
        }
        break;

      default:
        break;
    }

    // fetch calendar data
    try {
      const calendarLink = store.getters.getStoreVar(
        "Home",
        "styling",
        "text",
        "calendarLink"
      );
      if (calendarLink) {
        await store.dispatch("api/fetchCalendar", { url: calendarLink });
      }
    } catch (err) {
      console.log(err);
    }

    // fetch tweet data
    try {
      await Promise.all(
        store.getters
          .getStoreVar("Home", "styling", "homeButtons", "homeButtons")
          .filter((button) => button.type === "Twitter")
          .map((button) => {
            const { url, confirmed } = button.data;
            const { buttonId } = button;
            return store.dispatch("api/fetchTweets", {
              username: url,
              buttonId,
              confirmed,
            });
          })
      );
    } catch (err) {
      console.log(err);
    }
  }

  return {
    loadHomeData,
  };
}
